export default __webpack_public_path__ + "static/media/icon_sales.4ec4bbf9.svg";